export const ESPECIFICACAO_GRUPO_TIPO_TO_LABEL = {
    'situacao': 'Situação',
    'desvio': 'Desvio',
    'lado': 'Lado',
}

export const ESPECIFICACAO_TO_LABEL = {
    // 'localizado_entre_dentes': 'Localizado entre dentes',
    // 'localizado_distal_dente': 'Localizado à distal do dente',
    // 'localizado_entre_raizes_dentes': 'Localizado entre raízes de dentes',
    // 'localizado_distal_raiz_dente': 'Localizado à distal da raiz do dente',
    // 'localizado_acima_dente': 'Localizado acima do dente',
    // 'localizado_abaixo_dente': 'Localizado abaixo do dente',
    'localizado_entre_dentes': 'Entre dentes',
    'localizado_distal_dente': 'À distal do dente',
    'localizado_entre_raizes_dentes': 'Entre raízes de dentes',
    'localizado_entre_raizes_dente': 'Entre raízes do dente',
    'localizado_distal_raiz_dente': 'À distal da raiz do dente',
    'localizado_acima_dente': 'Acima do dente',
    'localizado_abaixo_dente': 'Abaixo do dente',
    'localizado_mandibula_abaixo_dente': 'Base da mandíbula, abaixo do dente',
    'regiao_dente': 'Região do dente',
    'regiao_dentes': 'Região de dentes',
    'provavel_regiao_dente': 'Provável região do dente',
    'provavel_regiao_dentes': 'Provável região de dentes',
    'regiao_palatina': 'Região palatina',
    'entre_dentes': 'Entre dentes',
    'proximo_apice_dente': 'Próximo ao ápice de dente',
    'proximo_dente': 'Próximo ao dente',
    'abaixo_dente': 'Abaixo do dente',
    'acima_dente': 'Acima do dente',
    'distal_dente': 'À distal do dente',
    'entre_raizes_dentes': 'Entre raízes de dentes',
    'entre_raizes_dente': 'Entre raízes do dente',
    'distal_raiz_dente': 'À distal da raiz do dente',
    'para_direita': 'Para a direita',
    'para_esquerda': 'Para a esquerda',
    'direito': 'Lado direito',
    'esquerdo': 'Lado esquerdo',
    'ambos': 'Ambos os lados',
}